module.exports = __webpack_public_path__ + "img/avatar2.30078647.png";